import React, {useEffect} from 'react';
import { useSelector } from 'react-redux';
import { client }  from '../OwnWebsocket';
import {useNavigate} from "react-router-dom";
import Player from '@vimeo/player';

function Tracking() { 
  var ScreenData = "";

  const WebSocketBucketState = useSelector((state) => state.WebSocketBucket);
  //console.log(WebSocketBucketState, 'websocket updated');

  useEffect(() => {
     console.log("tracking run");
      /******Send Data User To Admin with PlayerJS*****/
      var interval = null;
      //var iframe = document.querySelector('iframe[id="livevideoiframe"]');
      var iframe = document.querySelector('iframe[id="livevideoiframe"]');
  
      if(iframe){
          var player;
          player = "";
          player = new Player(iframe);
          var start_duration;
          var current_time;
          var video_id;
          var video_title;
  
            player.pause();
            
            clearInterval(interval, "clear previous interval"); // stop previous the interval

            player.on('play', function() {
                console.log('played the video!!!!');
    
                clearInterval(interval); // stop previous the interval
                //get start time
                player.getCurrentTime().then(function(seconds) {
                    start_duration = seconds;
                    player.getVideoId().then(function(id) {
                    video_id = id;
                        player.getVideoTitle().then(function(title){
                        video_title = title;
    
                        //send Data Onplay
                        var data = {
                        video_id: video_id,
                        video_title: video_title,
                        start_duration: start_duration,
                        action: 'initSetPlayeTimestamp'
                        };
    
                        //initilize after 30 seconds after click on play button
                        setTimeout(function(){ 
                            console.log('Player Inner');
                            if(client.readyState!=0 && client.readyState!=3){
                                client.send(JSON.stringify(data));
                            }
                           
                             /***run on every 2 minutes****/

                             interval = setInterval(setUserWatchedVideoData,120000);

                        }, 2000);
                        
    
                        });
                    });
                });
                
            });


            function setUserWatchedVideoData(){ 
                console.log("Interval Method");
                player.getCurrentTime().then(function(seconds) {
                    current_time = seconds;
                    console.log(start_duration+'  '+current_time);
                    var data = {
                    current_time: current_time,
                    action: 'pushUserToAdmin'
                    };
                    if(client.readyState!=0 && client.readyState!=3){
                        client.send(JSON.stringify(data));
                    }
    
                });
    
            }        
    
            player.on('pause', function(data) {
                console.log("paused");
                clearInterval(interval); // stop the interval
            });
    
            player.on('ended', function(data) {
                console.log("Video End");
                clearInterval(interval); // stop the interval
                // navigate('/');
            });
  
        }

          return () => clearInterval(interval);

  });

}

export default Tracking;